var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamelogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "iv4jrnxx6a",
    d: "M0 0L11.136 0 11.136 20 0 20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-412 -246) translate(412 246)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l6o1z0nzqb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iv4jrnxx6a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M6.73 1.266l.073-.26h-2.49l.065.26H6.73zm-5.277-.26c-.246 0-.447.2-.448.447v17.094c.001.246.202.447.448.447h8.23c.246 0 .446-.201.447-.447V1.453c0-.247-.2-.447-.447-.447H7.848l-.252.899c-.062.217-.26.367-.485.367H3.985c-.23 0-.432-.156-.488-.381l-.222-.885H1.453zm0 18.994c-.8-.001-1.452-.652-1.453-1.452V1.453C.001.653.652.001 1.452 0h8.231c.8.001 1.452.653 1.453 1.452v17.095c0 .801-.653 1.452-1.452 1.453h-8.23z",
    mask: "url(#l6o1z0nzqb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M4.46 18.34c-.277 0-.503-.226-.503-.502 0-.277.226-.503.503-.503h2.216c.277 0 .503.226.503.503 0 .276-.226.503-.503.503H4.46z",
    transform: "translate(-412 -246) translate(412 246)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelogo1);
export default __webpack_public_path__ + "static/media/gamelogo1.dac29357acc2a60bbbb3cc6ddac10414.svg";
export { ForwardRef as ReactComponent };